import { Component, Input } from '@angular/core';
import { NavigationComponent } from '@presencelearning/ui';
import { PL_ROUTING } from '@common/constant';
import { environment } from '@environments/environment';

@Component({
  selector: 'pl-header',
  templateUrl: './pl-header.component.html',
  styleUrls: ['./pl-header.component.scss'],
})
export class PlHeaderComponent {
  @Input() navigation: NavigationComponent | null = null;

  readonly homeLink = `/${PL_ROUTING.LANDING_HOME}`;

  readonly previewTicket = environment.preview_alias?.toUpperCase() ?? null;
}
